import { UtilizationService } from "@common/client"
import { aircraftBaseKey, fittedComponentsBaseKey } from "./aircraft"
import { makeAxiosMutation, makeQuery } from "./utils"

export const utilizationBaseKey = ["utilization"] as const

export const aircraftUtilizationKey = (aircraftId: string) =>
  [...utilizationBaseKey, "aircraft", aircraftId] as const

export const partInstanceUtilizationKey = (partInstanceId: string) =>
  [...utilizationBaseKey, "part-instance", partInstanceId] as const

export const aircraftUtilizationQuery = makeQuery({
  serviceCall: (aircraftId: string) =>
    UtilizationService.listAircraftReadings({ aircraft_id: aircraftId }),
  queryKey: aircraftUtilizationKey,
})

export const partInstanceUtilizationQuery = makeQuery({
  serviceCall: (partInstanceId: string) =>
    UtilizationService.listPartInstanceReadings({
      part_instance_id: partInstanceId,
    }),
  queryKey: partInstanceUtilizationKey,
})

export const useRecordAircraftReadingMutation = makeAxiosMutation({
  serviceCall: UtilizationService.recordAircraftReading,
  invalidates: (params) => [
    aircraftUtilizationKey(params.aircraft_id),
    aircraftBaseKey,
    fittedComponentsBaseKey(params.aircraft_id),
  ],
})

export const useCreatePartInstanceReadingMutation = makeAxiosMutation({
  serviceCall: UtilizationService.createPartInstanceReading,
  invalidates: (params) => [
    partInstanceUtilizationKey(params.part_instance_id),
  ],
})

export const useUpdatePartInstanceReadingMutation = makeAxiosMutation({
  serviceCall: UtilizationService.updatePartInstanceReading,
  invalidates: (params) => [
    partInstanceUtilizationKey(params.part_instance_id),
  ],
})

export const useDeletePartInstanceReadingMutation = makeAxiosMutation({
  serviceCall: UtilizationService.deletePartInstanceReading,
  invalidates: (params) => [
    partInstanceUtilizationKey(params.part_instance_id),
  ],
})
